export * from './resource-price.component';
